import { Router } from '@angular/router';
import { PlaybackState } from '../../models/common/video-playback.model';
import { effectiveStreamStatus } from '../../features-modules/videos/utils/video-stream.util';

export interface VideoStreamData {
  id: string | number;
  streaming_platform?: string;
  stream_status?: string;
  playback_state?: PlaybackState | null;
  asset_playback_id?: string | null;
  /** Set on a Full Day Stream part card; the watch screen plays that recording. */
  part?: { number: number };
}

/** Query param carrying the Full Day Stream part to play. */
export const VIDEO_PART_QUERY_PARAM = 'part';

export function storeVideoSession(data: VideoStreamData): void {
  if (globalThis.window?.sessionStorage) {
    sessionStorage.setItem('view_video', JSON.stringify(data));
  }
}

function resolveVideoRoute(
  data: VideoStreamData,
  basePath: 'live' | 'videos',
  requireAssetForScheduled: boolean,
): string[] {
  const streamStatus = effectiveStreamStatus(data);
  if (streamStatus === 'L') {
    return [`${basePath}/1/${data.id}`];
  }
  if (streamStatus === 'S') {
    if (!requireAssetForScheduled || data.asset_playback_id) {
      return [`${basePath}/0/${data.id}`];
    }
  }
  return [`${basePath}/-1/${data.id}`];
}

export function navigateToVideoStream(
  router: Router,
  data: VideoStreamData,
  options: {
    live: boolean;
    requireAssetForScheduled?: boolean;
  },
): void {
  storeVideoSession(data);

  if (data.streaming_platform === 'IVS') {
    openVideoRoute(router, resolveVideoRoute(data, 'live', false), data.part);
    return;
  }

  const basePath = options.live ? 'live' : 'videos';
  const requireAsset =
    options.requireAssetForScheduled ?? !options.live;
  openVideoRoute(router, resolveVideoRoute(data, basePath, requireAsset), data.part);
}

/** A part card adds `?part=N`; any other navigation drops the query param. */
function openVideoRoute(router: Router, commands: string[], part: VideoStreamData['part']): void {
  if (part) {
    router.navigate(commands, { queryParams: { [VIDEO_PART_QUERY_PARAM]: part.number } });
  } else {
    router.navigate(commands);
  }
}
